module.exports = __webpack_public_path__ + "img/6.81cc025a.jpg";